import { ButtonLink } from 'react-router-bootstrap';
import { Link } from 'react-router';
import React from 'react';
import { Table } from 'react-bootstrap';
import Restriction from './Restriction';
import restriction from "./Restriction";
import Invocation from "../../api/Invocation";
import ClientStore from "../../stores/ClientStore";
import DateRange from "../../util/DateRange";
import Currency from "../../util/Currency";

var ClientServiceStore = require('../../stores/ClientServiceStore');
var Ip = require('../../util/Ip');
var Loading = require('../Loading');
var Search = require('../../util/Search');
var ServiceActions = require('../../actions/ServiceActions');
var ServiceTypes = require('../../constants/ServiceTypes');
var UserStore = require('../../stores/UserStore');

function getState() {
    var services = ClientServiceStore.get();
    var billingGroups = [];
    var hasRestrictions = false;

    services.forEach(function (service) {
        if (!billingGroups[service.billing_group.id]) {
            billingGroups[service.billing_group.id] = service.billing_group;
            billingGroups[service.billing_group.id].services = [];
        }
        billingGroups[service.billing_group.id].services.push(service);

        if (service.restrictions) {
            for (let i = 0; i < service.restrictions.length; i++) {
                const restrictionType = service.restrictions[i].type;
                if (restrictionType.match(/^(overdue_suspension|overlimit_shaped|overlimit)$/)) {
                    hasRestrictions = true;
                }
            }
        }
    }, this);

    return {
        billingGroups: billingGroups.filter(({ services }) => services.length),
        hasRestrictions: hasRestrictions,
        loadedServiceCount: ClientServiceStore.get().length,
        loading: !ClientServiceStore.has(),
        priceColumnState: ClientServiceStore.has() && ClientServiceStore.get().length ? (!!ClientServiceStore.get()[0].accounting) : undefined,
        search: ''
    };
}

var ServiceTable = React.createClass({
    propTypes: {
        hideSingleBillingGroup: React.PropTypes.bool.isRequired,
        showIpAddress: React.PropTypes.bool.isRequired,
        showSite: React.PropTypes.bool.isRequired,
        widgetName: React.PropTypes.string.isRequired
    },
    statics: {
        getIcon: function (service) {
            if (service.authentication && service.authentication.active_disable) {
                return <i className="fa fa-warning text-red" title="Suspended" />
            }

            if (service.hasOwnProperty('restrictions') && service.restrictions.length) {
                return <i className="fa fa-warning text-red"></i>;
            }

            return <i className="fa fa-search" title="View Service"></i>;
        }
    },
    buildBillingGroup: function (filterText, billingGroup, key) {
        var rows = billingGroup.services.map(this.buildServiceRow.bind(this, filterText)).filter((row) => !!row);
        if (rows.length == 0) {
            return null;
        }

        return <tbody key={key}>
            {this.buildBillingGroupHeader(billingGroup)}
            {rows}
        </tbody>;
    },
    buildBillingGroupContact: function (contact) {
        if (!contact) {
            return;
        }

        return <small>Primary Contact: {contact.first_name} {contact.last_name} ({contact.email})</small>;
    },
    buildBillingGroupHeader: function (billingGroup) {
        if (!this.showBillingGroups()) {
            return;
        }

        return <tr>
            <th colSpan={this.getColspan()}>
                <h4>{billingGroup.name}</h4>
                {this.buildBillingGroupContact(billingGroup.contact)}
            </th>
        </tr>;
    },
    buildServiceRow: function (filterText, service, key) {
        var ipCol;
        if (this.props.showIpAddress && service.transit) {
            ipCol = <td>{service.transit.wan_ip && Ip.format(service.transit.wan_ip)}</td>;
        } else if (this.props.showIpAddress) {
            ipCol = <td></td>;
        }

        const name = Ip.format(service.identifier, true);
        const site = this.props.showSite && service.site ?
            service.site.name :
            null;
        const icon = ServiceTable.getIcon(service);
        const type = service.service.group ?
            ServiceTypes.getType(service.service.group) :
            ServiceTypes.getTypeByConstant(service.service.type);
        const restrictions = (service.restrictions || []).map(
            (restriction, i) => <Restriction key={i} restriction={restriction} />
        );
        const accounting = service.accounting;

        var searchableTerms = [
            type.name,
            name,
            this.props.showSite && service.site ? service.site.name : null,
            service.service.name,
            this.props.showIpAddress && service.transit && service.transit.wan_ip ? Ip.format(service.transit.wan_ip) : null
        ];

        if (!Search.isMatch(filterText, searchableTerms.join(' '))) {
            return null;
        }

        return <tr key={key}>
            <td>
                <h5>{service.service_display_name}</h5>
                {site}
                {restrictions}
            </td>
            <td>
                <Link to="service" params={{serviceId: service.id}}>{icon} {name}</Link>
            </td>
            <td>
              {service.clientReference}

              <span>
                {service.clientReference && (<br />)}
                <small className="text-muted">{service.reference}</small>
              </span>
            </td>
            {accounting && <td>
                {accounting.interval_price !== accounting.interval_price_without_coupons &&
                    <span><strike>{Currency.format(accounting.interval_price_without_coupons)} / {DateRange.simpleFormat(service.accounting.interval)}</strike> <br /></span>}
                <strong>{Currency.format(accounting.interval_price)} / {DateRange.simpleFormat(service.accounting.interval)}</strong>
            </td>}
            {ipCol}
        </tr>;
    },
    getDefaultProps: function () {
        return {
            allowSearch: false,
            hideSingleBillingGroup: false,
            showIpAddress: true,
            showSite: true
        }
    },
    getInitialState: function () {
        return getState();
    },
    showBillingGroups: function () {
        return this.state.billingGroups.length > 1 ||
            (this.state.billingGroups.length == 1 && !this.props.hideSingleBillingGroup)
            ;
    },
    componentDidMount: function() {
        ClientServiceStore.addChangeListener(this._onChange);
        UserStore.addChangeListener(this.componentWillMount);
    },
    componentWillMount: function () {
        var user = UserStore.getUser();

        if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
            ServiceActions.getServices(user);
        }
    },
    componentWillUnmount: function () {
        ClientServiceStore.removeChangeListener(this._onChange);
        UserStore.removeChangeListener(this.componentWillMount);
    },
    filterValueChanged: function (e) {
        this.setState({search: e.target.value});
    },
    getColspan: function () {
        return 4 + this.props.showIpAddress + (this.state.priceColumnState !== false);
    },
    getServices: function (filterText) {
        const colspan = this.getColspan();

        if (this.state.loading) {
            return <tbody><tr><td colSpan={colspan}><Loading /></td></tr></tbody>;
        }

        if (!this.state.billingGroups.length) {
            return <tbody><tr><td colSpan={colspan}>
                You have no active services. <a href={_SIGNUP_BASE + '/login'} className="btn btn-primary btn-xs" target="_blank">
                    <i className="fa fa-plus"></i> Add New Service
                </a>
            </td></tr></tbody>;
        }

        return this.state.billingGroups.map(this.buildBillingGroup.bind(this, filterText));
    },
    handleReportButtonClick: function (e) {
        let link = $(e.target);
        if (!link.is('a')) {
            link = link.closest('a');
        }

        link.attr('href', Invocation.clientService.buildServicesReportUrl(ClientStore.get().id));
    },
    render: function () {
        var services = this.getServices(this.state.search);
        var ipHeader = this.props.showIpAddress ? <th>Primary IP Address</th> : null;

        var header = <tr>
            <th>Service Type</th>
            <th>Identifier</th>
            <th>Reference</th>
            {this.state.priceColumnState === true && <th>Price</th>}
            {this.state.priceColumnState === undefined && <th></th>}
            {ipHeader}
        </tr>;

        var filter, footerHeader, downloadServiceReportLink;

        if (this.state.loadedServiceCount > 5) {
            if (this.props.allowSearch) {
                filter = <div className="dataTables_filter">
                    <label>Search: <input ref="filter" className="form-control" value={this.state.search} onChange={this.filterValueChanged} /></label>
                </div>;

                downloadServiceReportLink = <a className="btn btn-sm btn-default" href="#" target="_blank" onClick={(e) => this.handleReportButtonClick(e)}>
                    <i className="fa fa-download"></i> Download Service Report
                </a>;
            }

            footerHeader = <tfoot>{header}</tfoot>;
        }

        var restrictionWarning;
        if (this.state.hasRestrictions) {
            restrictionWarning = <div className="callout callout-danger">
                <p>
                    Some of the services below have restrictions applied. Please check individual
                    services
                </p>
            </div>;
        }

        return <section className="powerwidget green clientService-table">
            <header><h2>{this.props.widgetName}</h2></header>
            <div className="inner-spacer">
                {this.props.children}
                {restrictionWarning}
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div>{filter}</div>
                    <div>{downloadServiceReportLink}</div>
                </div>
                <div className="table-responsive">
                    <Table className="table-striped table-hover">
                        <thead>{header}</thead>
                        {services}
                        {footerHeader}
                    </Table>
                </div>
            </div>
        </section>;
    },
    _onChange: function() {
        this.setState(getState());
    }
})
module.exports = ServiceTable;



// WEBPACK FOOTER //
// ./app/components/ClientService/Table.js